var map = {
	"./product-bh/products-night.json": [
		6341,
		341
	],
	"./product-en/products-night.json": [
		6474,
		474
	],
	"./product-kr/products-night.json": [
		7104,
		104
	],
	"./product-sc/products-night.json": [
		2493,
		493
	],
	"./product-tc/products-night.json": [
		796,
		796
	],
	"./product-th/products-night.json": [
		1903,
		903
	],
	"./product-vn/products-night.json": [
		1267,
		267
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6688;
module.exports = webpackAsyncContext;